export enum UserAuthMethodEnum {
  ONE_TIME = 'one-time',
  SOCIAL_LOGIN = 'social-login',
  NO_AUTH = 'no-auth',
  ID_PW = 'id-pw',
}
